@import "../../global/gx-ide-mixins.scss";
@import "../../global/temporary-mercury-overrides/_button.scss";
@import "../../../node_modules/@genexus/mercury/dist/assets/scss/helpers.scss";

:host {
  container-type: inline-size;
  display: grid;
  block-size: 100%;
  overflow: auto;
  grid-template-rows: max-content 1fr max-content;
}

.section {
  display: contents;
}

// - - - - - - - - - - - -
// Header
// - - - - - - - - - - - -

.header {
  grid-template-areas:
    "name module-folder"
    "advanced-filter advanced-filter";
  grid-template-columns: 1fr 1fr;
  grid-auto-rows: max-content max-content;
}
.name {
  grid-area: name;
}
.module-folder {
  grid-area: module-folder;
}
.advanced-filter {
  grid-area: advanced-filter;
}

// Advanced Filter
.advanced-filter {
  &__container {
    display: grid;
    grid-auto-rows: max-content;
  }
  &__first-row {
    grid-template-columns: 1fr 1fr;
  }
  &__second-row {
    grid-template-columns: 1fr 1fr 1fr;
  }
  .all-descendants__modified {
    display: flex;
    flex-direction: row;
    align-items: center;
    block-size: 32px;
    gap: var(--spacing-gap-xl);
    align-self: self-end;
  }
}
// date/time
.field-date {
  grid-template-areas:
    "label-date-time label-date-time"
    "input-date-time icon-clear-date-time";
  grid-template-columns: 1fr max-content;
  column-gap: var(--spacing-gap-xs);
}
.label-date-time {
  // WA: There is no official way to use an icon (ch-image) within a label
  display: flex;
  align-items: center;
  gap: var(--spacing-gap-m);
  .icon-s {
    // WA: Icon looks so small that it is not recognizable
  }
  grid-area: label-date-time;
}
.input-date-time {
  block-size: 32px;
  grid-area: input-date-time;
}
.icon-clear-date-time {
  grid-area: icon-clear-date-time;
}

// - - - - - - - - - - - -
// Grid
// - - - - - - - - - - - -

.tabular-grid {
  overflow: auto;
  inline-size: 100%;
  border-inline-end: var(--section-common-border);
}
.tabular-grid.empty::part(main),
.tabular-grid.loading::part(main) {
  // WA to avoid scrollbar flickering when displaying the empty-state message
  overflow: hidden;
}
ch-tabular-grid-rowset-empty {
  position: relative;
}
.main__files-container {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: var(--spacing-gap-m);
  position: relative;
  z-index: 1;
}

@include hiChar;

@include tabular-grid-cell-layout(
  $tabular-grid-selector: ".tabular-grid",
  $tabular-grid-cell-node-type: "text",
  $tabular-grid-cell-apply-ellipsis: true,
  $tabular-grid-affected-columns-nth-list: (
    4
  )
);
.tabular-grid-cell-description {
  min-inline-size: max-content !important; // TODO: See how to remove the !important
}

@include hiChar();

// - - - - - - - - - - - -
// Responsive
// - - - - - - - - - - - -

// @container (max-width: 992px) {
//   .main__files-container {
//     grid-template-columns: repeat(3, 1fr);
//   }
// }
